import {
  AfterViewInit,
  Component, effect, ElementRef,
  input,
  InputSignal,
  InputSignalWithTransform,
  model,
  ModelSignal, OnInit,
  output,
  Output, Signal, viewChild
} from '@angular/core';
import {NgClass} from "@angular/common";
import {ControlValueAccessor, FormControl, FormsModule, NgModel, ReactiveFormsModule} from "@angular/forms";

@Component({
  selector: 'app-checkbox',
  standalone: true,
  imports: [
    NgClass,
    FormsModule,
    ReactiveFormsModule
  ],
  templateUrl: './checkbox.component.html',
  styleUrl: './checkbox.component.scss',
  styles:  ":host{ @apply relative grid content-center w-fit; }",
})
export class CheckboxComponent {

  private readonly margins:{[key:number]:string} = {
    0: "",
    1: "m-1",
    2: "m-2",
    3: "m-3",
    4: "m-4"
  }

  public label: InputSignal<string> = model('');
  public color: InputSignal<string> = model('primary');
  public size: InputSignal<string> = model('medium');
  public value: InputSignal<boolean> = model(false);
  public disabled: ModelSignal<boolean> = model(false);
  public formController: ModelSignal<any> = model(null);
  public margin:InputSignalWithTransform<string, number> = input<string,number>( 'm-2', { transform: (value: number) => this.margins[value]} );
  public change = output<boolean>()

  private readonly checkbox: Signal<ElementRef<HTMLInputElement>> = viewChild('checkbox');

  constructor() {
    effect(() => {
      if(this.checkbox()) this.checkbox().nativeElement.checked = this.value();
    });
  }

  protected toggle(value: boolean, event: Event) {
    event.stopPropagation();
    this.change.emit(value);
  }

}
